import style from './rodingenerateboard.module.css'
import { useEffect, useRef, useState } from 'react';
import GeometryGeneration from "./components/Geometry";
import MaterialGeneration from "./components/Material";
import RodinPack from "./components/Pack";
import Story from "./components/Story";
import Tags from "./components/Tag";
import AssetGallery from "./components/AssetGallery";
import { PublishFooter } from "./components/publishFooter";
import CommentList from "./components/CommentList";
import * as Sentry from "@sentry/react";
import { driver } from 'driver.js';
import { ErrorPage } from "../../ErrorPage";
import {checkMobile} from "../../../utils/format";
const Fallback = <ErrorPage />;

function RodinGenerateBoard() {
    const bodyRef = useRef(null)
    const geomWrapperRef = useRef(null)
    const packWrapperRef = useRef(null)
    const isMtlGeneratingRef = useRef(true)
    const [currentStage, setCurrentStage] = useState(0)
    const isMobile = checkMobile()
    const switchFrame = () => {
        setCurrentStage(currentStage === 0 ? 1 : currentStage === 1 ? 2 : 0);
    }

    // On safari, display flex will cause history not showing up
    // TODO: Is there a better way to handle this?
    useEffect(() => {
        const bodyElement = bodyRef.current;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (bodyElement) {
            bodyElement.style.display = isSafari && !isMobile ? 'block' : 'flex';
        }
    }, []);

    const driverConfirmGuide = (newTarget) => {
        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
            animate:true,
            onHighlightStarted: () => {
                setTimeout(()=>{
                    const overlay = document.getElementsByClassName('driver-overlay')
                    if(overlay.length>0){
                        overlay[0].style.transition = 'opacity 0.3s ease'
                        overlay[0].style.opacity = 1
                    }
                },10)
            },
            onDestroyStarted: () => {
                const overlay = document.getElementsByClassName('driver-overlay')
                if(overlay.length>0){
                    overlay[0].style.transition = 'opacity 0.2s ease'
                    overlay[0].style.opacity = 0
                    setTimeout(()=>{driverObj.destroy()},200)
                } 
            }
        });
        const target = newTarget
        driverObj.highlight({
            element: target,
        })
        setTimeout(()=>{
            const overlay = document.getElementsByClassName('driver-overlay')
            if(overlay.length>0){
                overlay[0].style.transition = 'opacity 0.2s ease'
                overlay[0].style.opacity = 0
                setTimeout(()=>{driverObj.destroy()},200)
            } 
        },500)
    }

    return (
        <>
            <div id='rodinGenerateBoard' onClick={(e)=>{
                const confirmTab = document.getElementById('geoConfirmTab')
                const threeJs = document.getElementById('threeJsOverlay')
                console.log('threeJs',threeJs)
                if(confirmTab){
                    if(!geomWrapperRef.current.contains(e.target) && !threeJs.contains(e.target)){
                        driverConfirmGuide("#geoConfirmTab")
                    }
                }
                const downloadTab = document.getElementById('downloadTab')
                const matgenTab = document.getElementById('matGenerateTab')
                if(matgenTab){
                    if(downloadTab.contains(e.target)){
                        driverConfirmGuide("#matGenerateTab")
                    }
                }
                const matconfirmTab = document.getElementById('matConfirmTab')
                if(matconfirmTab){
                    if(downloadTab.contains(e.target)){
                        driverConfirmGuide("#matConfirmTab")
                    }
                }
            }} className={ style.container } style={isMobile ? {width: '100%'} : {}}>
                <div className={style.body} style={{marginTop: isMobile ? '20px' : '0px'}} ref={bodyRef}>
                    {currentStage === 0 && (
                        <>
                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <GeometryGeneration
                                    ref={geomWrapperRef}
                                    bodyRef={bodyRef}
                                    isMtlGeneratingRef={isMtlGeneratingRef}
                                />
                            </Sentry.ErrorBoundary>
                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <MaterialGeneration
                                    bodyRef={bodyRef}
                                    geomWrapperRef={geomWrapperRef}
                                    packWrapperRef={packWrapperRef}
                                    isMtlGeneratingRef={isMtlGeneratingRef} />
                            </Sentry.ErrorBoundary>
                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <RodinPack ref={packWrapperRef} />
                            </Sentry.ErrorBoundary>
                        </>
                    )}
                    {currentStage === 1 && (
                        <>
                            <Story currentStage={currentStage} />
                            <Tags />
                            <AssetGallery />
                            <PublishFooter />
                        </>
                    )}
                    {currentStage === 2 && (
                        <>
                            <Story currentStage={currentStage} />
                            <CommentList />
                        </>
                    )}
                </div>

                <button
                    onClick={switchFrame}
                    className="absolute right-[-60px] bottom-0 bg-white rounded-lg p-2 text-lg opacity-0"
                >
                    &#x25BC;
                </button>
            </div>
        </>
    )
}

export default RodinGenerateBoard
